<div class="flex flex-row items-center gap-2 user-cell-wrapper" (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave()" (mousemove)="onMouseMove($event)">
  <mat-icon class="user-icon" [style.color]="iconColor">account_circle</mat-icon>
  <a *ngIf="hasClickCallback; else noClick" class="px-2 py-0.5 rounded-full border border-gray-300 inline-block user-bubble user-link" (click)="onUserClick($event)">
    {{ userName }}
  </a>
  <ng-template #noClick>
    <span class="px-2 py-0.5 rounded-full border border-gray-300 inline-block user-bubble">
      {{ userName }}
    </span>
  </ng-template>
</div>
